import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

const composeDetailsSelect = (state: RootState) => state.campaignCompose;
const mediaDetailsSelect = (state: RootState) =>
  state.campaignCompose.mediaDetails;
const templateDetailsSelect = (state: RootState) =>
  state.campaignCompose.templateDetails;
const campaignSenderDetailsSelect = (state: RootState) =>
  state.campaignCompose.campaignSenderDetails;
const templatePlaceholdersSelect = (state: RootState) =>
  state.campaignCompose.templatePlaceholders;
const templatePlaceholdersCacheSelect = (state: RootState) =>
  state.campaignCompose.templatesPlaceholderCache;

const mediaDetailsSelector = createSelector(
  mediaDetailsSelect,
  (mediaDetails) => {
    return { mediaDetails };
  }
);

const templateDetailsSelector = createSelector(
  templateDetailsSelect,
  (templateDetails) => {
    return { templateDetails };
  }
);

const campaignSenderDetailsSelector = createSelector(
  campaignSenderDetailsSelect,
  (senderDetails) => {
    return { senderDetails };
  }
);

const templatePlaceholdersSelector = createSelector(
  templatePlaceholdersSelect,
  (templatePlaceholders) => {
    return { templatePlaceholders };
  }
);

const templatePlaceholdersCacheSelector = createSelector(
  templatePlaceholdersCacheSelect,
  (templatePlaceholdersCache) => {
    return { templatePlaceholdersCache };
  }
);

const composeDetailsSelector = createSelector(
  composeDetailsSelect,
  ({ campaignSenderDetails, mediaDetails, templateDetails }) => {
    const composeDetails = {
      campaignSenderDetails,
      mediaDetails,
      templateDetails,
    };
    return { composeDetails };
  }
);

export {
  mediaDetailsSelector,
  templateDetailsSelector,
  campaignSenderDetailsSelector,
  composeDetailsSelector,
  templatePlaceholdersSelector,
  templatePlaceholdersCacheSelector
};
